import React from 'react'
import ContentLoader from 'react-content-loader'

const Placeholder = (props) => (
  <ContentLoader
    speed={2}
    width={400}
    height={460}
    viewBox='0 0 400 460'
    backgroundColor='#f3f3f3'
    foregroundColor='#ecebeb'
    {...props}
  >
    <rect x='0' y='77' rx='2' ry='2' width='400' height='400' />
    <rect x='0' y='20' rx='0' ry='0' width='170' height='37' />
  </ContentLoader>
)

export default Placeholder
